module.exports = __webpack_public_path__ + "media/entities/25-28322fef.png";